// i18n config
export const LNG = 'zh_HK'
export const ZH = 'zh_HK'
export const ZH_CN = 'zh_CN'
export const EN = 'en_HK'
export const FALLBACK_LNG = 'zh_HK'


// module name
export const MODULE_LOGIN = 'login'
export const MODULE_REG = 'reg'
export const MODULE_FORGET_PWD = 'forget_pwd'
export const MODULE_RESET_PWD = 'reset_pwd'
export const MODULE_SIDEBAR = 'sidebar'
export const MODULE_INDIVIDUAL = 'individual'
export const MODULE_UPLOADBTN = 'upload_button'
export const MODULE_PREVIEW_ROUTER_FORM = 'preview_router_form'
export const MODULE_PAYMENT = 'payment'
export const MODULE_SUGGESTION = 'suggestion'
export const MODULE_WALLET = 'wallet'
export const MODULE_REPLY_SELECTION = 'reply_selection'

// key - global
export const KEY_TEXT_MODAL_TITLE = 'text_modal_title'

// key - Login
export const KEY_TEXT_LOGOUT_SUCCESSFULLY = 'logout'
export const KEY_TEXT_LOGIN_SUCCESSFULLY = 'login'
export const KEY_TEXT_BTN_LOGIN = 'text_btn_login'
export const KEY_TEXT_LINK_FORGET_PWD = 'link_forget_pwd'
export const KEY_PHD_ACCOUNT = 'phd_account'
export const KEY_PHD_PASSWORD = 'phd_password'
export const KEY_ERROR_ACCOUNT_NOT_FILL = 'account_not_filled'
export const KEY_ERROR_ACCOUNT_PASSWORD_ERROR = 'account_password_error'
//  key - Reg
export const KEY_TEXT_IPT_EMAIL = 'text_ipt_email'
export const KEY_TEXT_IPT_EMAIL_VCODE = 'text_ipt_email_vcode'
export const KEY_TEXT_BTN_VCODE = 'text_btn_vcode'
export const KEY_TEXT_IPT_PHONE = 'text_ipt_phone'
export const KEY_TEXT_IPT_PWD = 'text_ipt_pwd'
export const KEY_TEXT_IPT_PWD_CONFIRM = 'text_ipt_pwd_confirm'
export const KEY_TEXT_BTN_REG = 'text_btn_reg'
export const KEY_TEXT_REG_SUCC = 'text_reg_succ'
export const KEY_ERROR_EMAIL_NOT_FILL = 'email_not_filled'
export const KEY_ERROR_EMAIL_VCODE_NOT_FILL = 'email_vcode_not_filled'
export const KEY_ERROR_PHONE_NOT_FILL = 'phone_not_filled'
export const KEY_ERROR_PASSWORD_NOT_FILL = 'password_not_filled'
export const KEY_ERROR_PASSWORD_CONFIRM_NOT_FILL = 'password_confirm_not_filled'
export const KEY_ERROR_PWD_NOT_SAME = 'password_not_same'
export const KEY_ERROR_REG_FAILED = 'reg_failed'
// key - ForgetPWD
export const KEY_TEXT_FORGETPWD_MODAL_TITLE = 'text_forgetpwd_modal_title'
export const KEY_BTN_FORGETPWD = 'btn_forgetpwd'
export const KEY_NOTI_SENT = 'noti_sent'
export const KEY_ERROR_SENT_FAILED = 'error_sent_failed'
// key - ResetPWD
export const KEY_TEXT_RESETPWD_MODAL_TITLE = 'text_resetpwd_modal_title'
export const KEY_BTN_RESETPWD = 'btn_resetpwd'
export const KEY_NOTI_RESET_SUCC = 'noti_reset_succ'
export const KEY_ERROR_RESET_FAILED = 'error_reset_failed'

// key - sidebar
export const KEY_TEXT_LABEL_ACCOUNT = 'account'
export const KEY_TEXT_LABEL_COMPANY = 'company'
export const KEY_TEXT_TAB_HOMEPAGE = 'homepage'
export const KEY_TEXT_TAB_ACCOUNT = 'service_account'
export const KEY_TEXT_SUBTAB_ACCOUNT_INFO = 'account_brief'
export const KEY_TEXT_SUBTAB_ACCOUNT_CONSULT = 'account_enquiry'
export const KEY_TEXT_SUBTAB_ACCOUNT_SERVICE = 'account_service'
export const KEY_TEXT_SUBTAB_ACCOUNT_ECARD = 'e_card'
export const KEY_TEXT_SUBTAB_ACCOUNT_NOTI = 'file_inform'
export const KEY_TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW = 'bill_and_renew'
export const KEY_TEXT_SUBTAB_ACCOUNT_PERMISSION = 'delegate_permission'
export const KEY_TEXT_TAB_ACCOUNT_INDIVIDUAL = 'personal_account'
export const KEY_TEXT_TAB_WALLET = 'wallet'
export const KEY_TEXT_TAB_REQUEST_SERVICE = 'request_a_service'
export const KEY_TEXT_TAB_MANUAL = 'manual'
export const KEY_TEXT_TAB_SUGGESTION_AND_ENQUIRY = 'suggestion_and_enquiry'
export const KEY_TEXT_TAB_USER_MANAGEMENT = 'tab_user_management'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT = 'tab_service_management'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_SERVICES = 'tab_service_management_services'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_CREDITS = 'tab_service_management_credits'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK = 'tab_service_management_hk'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_L = 'tab_service_management_hk_l'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_HK_UL = 'tab_service_management_hk_Ul'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS = 'tab_service_management_os'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_BVI = 'tab_service_management_os_bvi'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_CAYMAN = 'tab_service_management_os_cayman'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_OS_SEYCHELLES = 'tab_service_management_os_seychelles'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_SO = 'tab_service_management_so'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VO = 'tab_service_management_vo'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_CS = 'tab_service_management_cs'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS = 'tab_service_management_as'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_PROXY = 'tab_service_management_as_proxy'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_AS_TAX = 'tab_service_management_as_tax'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED = 'tab_service_management_val_added'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BE = 'tab_service_management_val_added_be'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BNC = 'tab_service_management_val_added_bnc'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_CSL = 'tab_service_management_val_added_csl'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_TR = 'tab_service_management_val_added_tr'
export const KEY_TEXT_TAB_SERVICE_MANAGEMENT_VAL_ADDED_BAR = 'tab_service_management_val_added_bar'
export const KEY_TEXT_TAB_INDIVIDUAL = 'tab_individual'
export const KEY_TEXT_TAB_APPLY_FORM = 'tab_apply_form'
export const KEY_TEXT_TAB_APPLY_FORM_HK = 'tab_apply_form_hk'
export const KEY_TEXT_TAB_APPLY_FORM_HK_L = 'tab_apply_form_hk_l'
export const KEY_TEXT_TAB_APPLY_FORM_HK_UL = 'tab_apply_form_hk_ul'
export const KEY_TEXT_TAB_APPLY_FORM_OS = 'tab_apply_form_os'
export const KEY_TEXT_TAB_APPLY_FORM_OS_BVI = 'tab_apply_form_os_bvi'
export const KEY_TEXT_TAB_APPLY_FORM_OS_CAYMAN = 'tab_apply_form_os_cayman'
export const KEY_TEXT_TAB_APPLY_FORM_OS_SEYCHELLES = 'tab_apply_form_os_seychelles'
export const KEY_TEXT_TAB_APPLY_FORM_SO = 'tab_apply_form_so'
export const KEY_TEXT_TAB_APPLY_FORM_VO = 'tab_apply_form_vo'
export const KEY_TEXT_TAB_APPLY_FORM_CS = 'tab_apply_form_cs'
export const KEY_TEXT_TAB_APPLY_FORM_CS_1 = 'tab_apply_form_cs_1'
export const KEY_TEXT_TAB_APPLY_FORM_AS = 'tab_apply_form_as'
export const KEY_TEXT_TAB_APPLY_FORM_AS_PROXY = 'tab_apply_form_as_proxy'
export const KEY_TEXT_TAB_APPLY_FORM_AS_TAX = 'tab_apply_form_as_tax'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED = 'tab_apply_form_val_added'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BE = 'tab_apply_form_val_added_be'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BNC = 'tab_apply_form_val_added_bnc'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_CSL = 'tab_apply_form_val_added_csl'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_TR = 'tab_apply_form_val_added_tr'
export const KEY_TEXT_TAB_APPLY_FORM_VAL_ADDED_BAR = 'tab_apply_form_val_added_bar'
export const KEY_TEXT_TIPS_I18N = 'text_tips_i18n'

// key - PAccount
export const KEY_COL_LABEL_NAME_CN = 'col_label_name_cn'
export const KEY_COL_LABEL_NAME = 'col_label_name'
export const KEY_COL_LABEL_APPLIER = 'col_label_applier'
export const KEY_COL_LABEL_PACKAGE = 'col_label_package'
export const KEY_COL_LABEL_UPDATEDAT = 'col_label_updatedat'
export const KEY_COL_LABEL_STATUS = 'col_label_status'
export const KEY_COL_LABEL_OPERATION = 'col_label_operation'
export const KEY_NOTI_SENT_RECP_SUCC = 'noti_sent_recp_succ'
export const KEY_ERROR_SENT_RECP_FAILED = 'error_sent_recp_failed'
export const KEY_NOTI_SENT_INV_SUCC = 'noti_sent_inv_succ'
export const KEY_ERROR_SENT_INV_FAILED = 'error_sent_inv_failed'
export const KEY_LABEL_DETAIL = 'label_detail'
export const KEY_LABEL_INVOICE = 'label_invoice'
export const KEY_LABEL_RECEIPT = 'label_receipt'
export const KEY_LABEL_HELLO = 'label_hello'
export const KEY_LABEL_CURRENT_CREDIT = 'label_current_credit'
export const KEY_LABEL_VALUE_ADDED = 'label_value_added'
export const KEY_LABEL_ADDED_RECORD = 'label_added_record'
export const KEY_LABEL_SEND_RECP = 'label_send_recp'
export const KEY_LABEL_RECP_ANNUAL = 'label_recp_annual'
export const KEY_LABEL_RECP_ANNUAL_START = 'label_recp_annual_start'
export const KEY_LABEL_RECP_ANNUAL_END = 'label_recp_annual_end'
export const KEY_LABEL_CONFIRM = 'label_confirm'
export const KEY_LABEL_CANCEL = 'label_cancel'

// key - UploadButton
export const KEY_LABEL_UPLOAD = 'label_upload'
export const KEY_NOTI_UPLOADED_SUCC = 'noti_uploaded_succ'
export const KEY_ERROR_UPLOADED_FAILED = 'error_uploaded_failed'

// key - Form
export const KEY_FORM_TITLE_1 = 'form_title_1'
export const KEY_FORM_TITLE_2 = 'form_title_2'
export const KEY_FORM_TITLE_3 = 'form_title_3'
export const KEY_FORM_TITLE_4 = 'form_title_4'
export const KEY_FORM_TITLE_5 = 'form_title_5'
export const KEY_FORM_TITLE_6 = 'form_title_6'
export const KEY_LABEL_FORM_NAME = 'label_form_name'
export const KEY_LABEL_FORM_TITLE = 'label_form_title'
export const KEY_LABEL_FORM_PHONE = 'label_form_phone'
export const KEY_LABEL_FORM_EMAIL = 'label_form_email'
export const KEY_LABEL_FORM_ADDRESS = 'label_form_address'
export const KEY_LABEL_FORM_CONTACT_WAY = 'label_form_contact_way'
export const KEY_LABEL_FORM_CONTACT_SLOT = 'label_form_contact_slot'
export const KEY_LABEL_FORM_COM_EN_NAME = 'label_form_com_en_name'
export const KEY_LABEL_FORM_COM_CN_NAME = 'label_form_com_cn_name'
export const KEY_LABEL_FORM_COM_ADDR = 'label_form_com_addr'
export const KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT = 'label_form_com_addr_use_default'
export const KEY_LABEL_FORM_COM_ADDR_REG = 'label_form_com_addr_reg'
export const KEY_LABEL_FORM_PRESET_SHARES = 'label_form_preset_shares'
export const KEY_LABEL_FORM_PRESET_SHARES_EN = 'label_form_preset_shares_en'
export const KEY_LABEL_FORM_IS_NUM = 'label_form_is_num'
export const KEY_LABEL_FORM_VAL = 'label_form_val'
export const KEY_LABEL_FORM_VAL_EN = 'label_form_val_en'
export const KEY_LABEL_FORM_VAL_TOTAL = 'label_form_val_total'
export const KEY_LABEL_FORM_VAL_TOTAL_EN = 'label_form_val_total_en'
export const KEY_LABEL_FORM_BUS_NATURE = 'label_form_bus_nature'
export const KEY_LABEL_FORM_BUS_REGION = 'label_form_bus_region'
export const KEY_LABEL_FORM_BOARD_NUM = 'label_form_board_num'
export const KEY_LABEL_FORM_VALUE_ADDED = 'label_form_value_added'
export const KEY_LABEL_FORM_UPLOADED_FILE = 'label_form_uploaded_file'
export const KEY_LABEL_FORM_BOARD_NO_BEFORE = 'label_form_board_no_before'
export const KEY_LABEL_FORM_BOARD_NO_AFTER = 'label_form_board_no_after'
export const KEY_LABEL_FORM_BOARD_INDENTITY = 'label_form_board_identity'
export const KEY_LABEL_FORM_BOARD_HOLADING = 'label_form_board_holding'
export const KEY_LABEL_FORM_BOARD_SH_EN_NAME = 'label_form_board_sh_en_name'
export const KEY_LABEL_FORM_BOARD_SH_CN_NAME = 'label_form_board_sh_cn_name'
export const KEY_LABEL_FORM_BOARD_SH_PHONE = 'label_form_board_sh_phone'
export const KEY_LABEL_FORM_BOARD_SH_EMAIL = 'label_form_board_sh_email'
export const KEY_LABEL_FORM_BOARD_SH_ADDRESS_BEFORE = 'label_form_board_sh_address_before'
export const KEY_LABEL_FORM_BOARD_SH_ADDRESS_AFTER = 'label_form_board_sh_address_after'
export const KEY_LABEL_FORM_BOARD_SH_ID_BEFORE = 'label_form_board_sh_id_before'
export const KEY_LABEL_FORM_BOARD_SH_ID_AFTER = 'label_form_board_sh_id_after'
export const KEY_LABEL_FORM_BOARD_SH_IC_BEFORE = 'label_form_board_sh_ic_before'
export const KEY_LABEL_FORM_BOARD_SH_IC_AFTER = 'label_form_board_ic_after'
export const KEY_LABEL_FORM_BOARD_COM_REG_ADDR = 'label_form_board_com_reg_addr'
export const KEY_LABEL_FORM_BOARD_COM_REG_NUM = 'label_form_board_com_reg_num'
export const KEY_LABEL_FORM_BOARD_COM_REG_BUS_NUM = 'label_form_board_com_reg_bus_num'
export const KEY_LABEL_FORM_BOARD_COM_REG_C = 'label_form_board_com_reg_c'
export const KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE = 'label_form_board_com_fund_source'
export const KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_BEFORE = 'label_form_board_com_fund_source_before'
export const KEY_LABEL_FORM_BOARD_COM_FUND_SOURCE_AFTER = 'label_form_board_com_fund_source_after'
export const KEY_NOTI_FORM_EDIT_SUCC = 'noti_form_edit_succ'
export const KEY_ERROR_FORM_EDIT_FAILED = 'error_form_edit_failed'
export const KEY_LABEL_FORM_EDIT = 'label_form_edit'
export const KEY_LABEL_FORM_CONFIRM = 'label_form_confirm'
export const KEY_LABEL_FORM_CANCEL = 'label_form_cancel'
export const KEY_LABEL_FORM_TITLE_MALE = 'label_form_title_male'
export const KEY_LABEL_FORM_TITLE_FEMALE = 'label_form_title_female'
export const KEY_LABEL_FORM_CONTACT_WAY_WTS = 'label_form_contact_way_wts'
export const KEY_LABEL_FORM_CONTACT_WAY_PHONE = 'label_form_contact_way_phone'
export const KEY_LABEL_FORM_CONTACT_WAY_EMAIL = 'label_form_contact_way_email'
export const KEY_LABEL_FORM_CONTACT_WAY_WECHAT = 'label_form_contact_way_wechat'
export const KEY_LABEL_FORM_CONTACT_WAY_WECHAT_NO = 'label_form_contact_way_wechat_no'
export const KEY_LABEL_FORM_CONTACT_SLOT_912 = 'label_form_contact_slot_912'
export const KEY_LABEL_FORM_CONTACT_SLOT_23 = 'label_form_contact_slot_23'
export const KEY_LABEL_FORM_CONTACT_SLOT_35 = 'label_form_contact_slot_35'
export const KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_YES = 'label_form_com_addr_use_default_yes'
export const KEY_LABEL_FORM_COM_ADDR_USE_DEFAULT_NO = 'label_form_com_addr_use_default_no'
export const KEY_LABEL_FORM_PRESET_SHARES_YES = 'label_form_preset_shares_yes'
export const KEY_LABEL_FORM_PRESET_SHARES_NO = 'label_form_preset_shares_no'
export const KEY_LABEL_FORM_BOARD_NUM_NEW = 'label_form_board_num_new'
export const KEY_LABEL_FORM_VALUE_ADDED_BE = 'label_form_value_added_be'
export const KEY_LABEL_FORM_VALUE_ADDED_CP = 'label_form_value_added_cp'
export const KEY_LABEL_FORM_VALUE_ADDED_CP_1 = 'label_form_value_added_cp_1'
export const KEY_LABEL_FORM_VALUE_ADDED_CP_2 = 'label_form_value_added_cp_2'
export const KEY_LABEL_FORM_VALUE_ADDED_CS = 'label_form_value_added_cs'
export const KEY_LABEL_FORM_VALUE_ADDED_CS_1 = 'label_form_value_added_cs_1'
export const KEY_LABEL_FORM_VALUE_ADDED_CS_2 = 'label_form_value_added_cs_2'
export const KEY_LABEL_FORM_VALUE_ADDED_BA = 'label_form_value_added_ba'
export const KEY_LABEL_FORM_VALUE_ADDED_TM = 'label_form_value_added_tm'
export const KEY_LABEL_FORM_VALUE_ADDED_CSE = 'label_form_value_added_cse'
export const KEY_LABEL_FORM_PREVIOUS = 'label_form_previous'
export const KEY_LABEL_FORM_NEXT = 'label_form_next'
export const KEY_LABEL_FORM_PREVIEW = 'label_form_preview'
export const KEY_LABEL_FORM_SUBMIT = 'label_form_submit'
export const KEY_ERROR_FORM_FILL_FORM = 'error_form_fill_form'
export const KEY_NOTI_FORM_SUBMIT_SUCC = 'noti_form_submit_succ'
export const KEY_ERROR_FORM_SUBMIT_FAILED = 'error_form_submit_failed'
export const KEY_LABEL_FORM_BOARD_INDENTITY_PERSONAL = 'label_form_board_indentity_personal'
export const KEY_LABEL_FORM_BOARD_INDENTITY_COMPANY = 'label_form_board_indentity_company'
export const KEY_LABEL_FORM_BOARD_INDENTITY_DIRECTOR = 'label_form_board_indentity_director'
export const KEY_LABEL_FORM_BOARD_INDENTITY_SHAREHOLDER = 'label_form_board_indentity_shareholder'
export const KEY_COL_LABEL_AMOUNT = 'col_label_amount'
export const KEY_LABEL_EXPORT_AS = 'label_export_as'
export const KEY_LABEL_EXPORT_AS_CSV = 'label_export_as_csv'
export const KEY_LABEL_EXPORT_AS_PDF = 'label_export_as_pdf'
export const KEY_NOTI_MSG_DELETE = 'noti_msg_delete'
export const KEY_LABEL_DELETE = 'label_delete'
export const KEY_LABEL_EXPORT_FILE_FORMAT = 'label_export_file_format'
export const KEY_LABEL_FORM_TABLE_TITLE = 'label_form_table_title'
export const KEY_LABEL_FORM_PIG_SINGULAR = 'label_form_pig_singular'
export const KEY_LABEL_FORM_PIG_PLURAL = 'label_form_pig_plural'
export const KEY_LABEL_FORM_PIG_MESSAGE = 'label_form_pig_message'
export const KEY_LABEL_FORM_PIG_ROWS_PER_PAGE = 'label_form_pig_rows_per_page'
export const KEY_LABEL_FORM_PIG_SELECT_ALL = 'label_form_pig_select_all'
export const KEY_COL_LABEL_USER_NAME = 'col_label_user_name'
export const KEY_COL_LABEL_USER_PHONE = 'col_label_user_phone'
export const KEY_COL_LABEL_USER_EMAIL = 'col_label_user_email'
export const KEY_COL_LABEL_USER_TITLE = 'col_label_user_title'
export const KEY_NOTI_DELETE_SUCC = 'noti_delete_succ'
export const KEY_ERROR_DELETE_FAILED = 'error_delete_failed'
export const KEY_NOTI_UPDATE_SUCC = 'noti_update_succ'
export const KEY_ERROR_UPDATE_FAILED = 'error_update_failed'
export const KEY_LABEL_PROFILE_TITLE = 'label_profile_title'
export const KEY_COL_LABEL_USER_ENQUIRY_TYPE = 'col_label_user_enquiry_type'
export const KEY_NOTI_REPLY_SUCC = 'noti_reply_succ'
export const KEY_ERROR_REPLY_FAILED = 'error_reply_failed'
export const KEY_LABEL_REPLY_PHD = 'label_reply_phd'
export const KEY_LABEL_REPLY = 'label_reply'
export const KEY_LABEL_SEARCH_COMPONENT_TYPE = 'label_search_component_type'
export const KEY_NOTI_CREATE_SUCC = 'noti_create_succ'
export const KEY_ERROR_CREATE_FAILED = 'error_create_failed'
export const KEY_LABEL_CREATE = 'label_create'
export const KEY_LABEL_NO_DATA_SHOW = 'label_no_data_show'
export const KEY_COL_PACKAGE_NAME = 'col_package_name'
export const KEY_COL_PACKAGE_PRICE = 'col_package_price'
export const KEY_COL_PACKAGE_CONTENT_TC = 'col_package_content_tc'
export const KEY_COL_PACKAGE_CONTENT_CN = 'col_package_content_cn'
export const KEY_COL_PACKAGE_CONTENT_EN = 'col_package_content_en'
export const KEY_COL_PACKAGE_DISCOUNT = 'col_package_discount'
export const KEY_COL_PACKAGE_DISCOUNT_START = 'col_package_discount_start'
export const KEY_COL_PACKAGE_DISCOUNT_END = 'col_package_discount_end'

export const KEY_FORM_VO_TITLE_1 = 'form_title_vo_1'
export const KEY_FORM_VO_TITLE_2 = 'form_title_vo_2'
export const KEY_FORM_VO_TITLE_3 = 'form_title_vo_3'
export const KEY_FORM_VO_TITLE_4 = 'form_title_vo_4'
export const KEY_FORM_VO_COL_IDENTITY = 'form_title_vo_col_identity'
export const KEY_FORM_VO_COL_IDENTITY_COM = 'form_title_vo_col_identity_com'
export const KEY_FORM_VO_COL_IDENTITY_IND = 'form_title_vo_col_identity_ind'
export const KEY_FORM_VO_COL_IDENTITY_ORG = 'form_title_vo_col_identity_org'
export const KEY_FORM_VO_COL_BUS_REG_LICENSE = 'form_title_vo_col_bus_reg_license'
export const KEY_FORM_VO_COL_BUS_REG_LICENSE_YES = 'form_title_vo_col_bus_reg_license_yes'
export const KEY_FORM_VO_COL_BUS_REG_LICENSE_NO = 'form_title_vo_col_bus_reg_license_no'
export const KEY_FORM_VO_COL_REG_DATE = 'form_title_vo_col_reg_date'
export const KEY_FORM_VO_COL_BUS_REG_NUM = 'form_title_vo_col_bus_reg_num'
export const KEY_FORM_VO_COL_NEED_UPLOAD_FILE = 'form_title_vo_col_need_upload_file'
export const KEY_FORM_VO_COL_FILE_BUG_REG_COPY = 'form_title_vo_col_file_bug_reg_copy'
export const KEY_FORM_VO_COL_MAIN_CONTACT = 'form_title_vo_col_main_contact'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY = 'form_title_vo_col_main_contact_identity'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_DIRECTOR = 'form_title_vo_col_main_contact_identity_director'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SH = 'form_title_vo_col_main_contact_identity_sh'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_SECRETARY = 'form_title_vo_col_main_contact_identity_secretary'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_STAFF = 'form_title_vo_col_main_contact_identity_staff'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_AGENT = 'form_title_vo_col_main_contact_identity_agent'
export const KEY_FORM_VO_COL_MAIN_CONTACT_TITLE = 'form_title_vo_col_main_contact_title'
export const KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MR = 'form_title_vo_col_main_contact_title_mr'
export const KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MISS = 'form_title_vo_col_main_contact_title_miss'
export const KEY_FORM_VO_COL_MAIN_CONTACT_TITLE_MRS = 'form_title_vo_col_main_contact_title_mrs'
export const KEY_FORM_VO_COL_MAIN_CONTACT_NAME_EN = 'form_title_vo_col_main_contact_name_en'
export const KEY_FORM_VO_COL_MAIN_CONTACT_NAME_CN = 'form_title_vo_col_main_contact_name_cn'
export const KEY_FORM_VO_COL_MAIN_CONTACT_PHONE = 'form_title_vo_col_main_contact_phone'
export const KEY_FORM_VO_COL_MAIN_CONTACT_EMAIL = 'form_title_vo_col_main_contact_email'
export const KEY_FORM_VO_COL_MAIN_CONTACT_ADDRESS = 'form_title_vo_col_main_contact_address'
export const KEY_FORM_VO_COL_MAIN_CONTACT_BIRTHDAY = 'form_title_vo_col_main_contact_birthday'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY = 'form_title_vo_col_main_contact_identity_verify'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_GOTOBANK = 'form_title_vo_col_main_contact_identity_verify_gotobank'
export const KEY_FORM_VO_COL_MAIN_CONTACT_IDENTITY_VERIFY_ONLINE = 'form_title_vo_col_main_contact_identity_verify_online'
export const KEY_FORM_VO_COL_MAIN_CONTACT_FILE_HKID_COPY = 'form_title_vo_col_main_contact_file_hkid_copy'
export const KEY_FORM_VO_CONFIRM = 'form_title_vo_confirm'
export const KEY_FORM_VO_TAC_TIPS = 'form_title_vo_tac_tips'
export const KEY_FORM_VO_TAC_COM_1 = 'form_title_vo_tac_com_1'
export const KEY_FORM_VO_TAC_COM_2 = 'form_title_vo_tac_com_2'
export const KEY_FORM_VO_TAC_COM_3 = 'form_title_vo_tac_com_3'
export const KEY_FORM_VO_COL_IND_FILE_ADDRESS_COPY = 'form_title_vo_col_ind_file_address_copy'
export const KEY_FORM_VO_COL_REG_CONNTRY = 'form_vo_col_reg_country'
export const KEY_FORM_VO_COL_ORG_NUM = 'form_vo_col_org_num'
export const KEY_FORM_VO_COL_ORG_FILE_ORG_COPY = 'form_title_vo_col_org_file_org_copy'
export const KEY_FORM_VO_TAC_IND_1 = 'form_title_vo_tac_ind_1'
export const KEY_FORM_VO_TAC_IND_2 = 'form_title_vo_tac_ind_2'
export const KEY_FORM_VO_TAC_ORG_1 = 'form_title_vo_tac_org_1'
export const KEY_FORM_VO_TAC_ORG_2 = 'form_title_vo_tac_org_2'

export const KEY_FORM_CS_TITLE_1 = 'form_title_cs_1'
export const KEY_FORM_CS_TITLE_2 = 'form_title_cs_2'
export const KEY_FORM_CS_TITLE_3 = 'form_title_cs_3'
export const KEY_FORM_CS_COL_SH_HOLDING = 'form_cs_col_sh_holding'
export const KEY_FORM_CS_COL_SC_COM = 'form_cs_col_sc_com'
export const KEY_FORM_CS_COL_SC_TITLE = 'form_cs_col_sc_title'
export const KEY_FORM_CS_COL_SC_NAME_CN = 'form_cs_col_sc_name_cn'
export const KEY_FORM_CS_COL_SC_NAME_EN = 'form_cs_col_sc_name_en'
export const KEY_FORM_CS_COL_SC_PHONE = 'form_cs_col_sc_phone'
export const KEY_FORM_CS_COL_SC_EMAIL = 'form_cs_col_sc_email'
export const KEY_FORM_CS_COL_SC_ADDR = 'form_cs_col_sc_addr'
export const KEY_FORM_CS_FILE_COM_REG = 'form_cs_file_com_reg'
export const KEY_FORM_CS_FILE_COM_POLICY = 'form_cs_file_com_policy'
export const KEY_FORM_CS_FILE_DIRECTOR_LIST = 'form_cs_file_director_list'
export const KEY_FORM_CS_FILE_SH_LIST = 'form_cs_file_sh_list'
export const KEY_FORM_CS_FILE_MAIN_CTR_LIST = 'form_cs_file_main_ctr_list'
export const KEY_FORM_CS_FILE_NAR1_LAST_YEAR = 'form_cs_file_nar1_last_year'
export const KEY_FORM_CS_FILE_NAR1_UPDATED_LAST_YEAR = 'form_cs_file_nar1_updated_last_year'
export const KEY_FORM_CS_FILE_DIRSH_ID = 'form_cs_file_director_sh_id'
export const KEY_FORM_CS_FILE_DIRECTOR_ADDRESS_VERIFY = 'form_cs_file_director_address_verify'

export const KEY_FORM_EX_CP_TITLE_1 = 'form_ex_cp_title_1'
export const KEY_FORM_EX_CP_TITLE_2 = 'form_ex_cp_title_2'
export const KEY_FORM_EX_CP_COL_ISBILINGUISH = 'form_ex_cp_col_isbilinguish'
export const KEY_FORM_EX_CP_COL_ISBILINGUISH_CN = 'form_ex_cp_col_isbilinguish_cn'
export const KEY_FORM_EX_CP_COL_ISBILINGUISH_EN = 'form_ex_cp_col_isbilinguish_en'
export const KEY_FORM_EX_CP_COL_ISBILINGUISH_OTHER = 'form_ex_cp_col_isbilinguish_other'
export const KEY_FORM_EX_CP_COL_POSITION_CN = 'form_ex_cp_col_position_cn'
export const KEY_FORM_EX_CP_COL_POSITION_EN = 'form_ex_cp_col_position_en'
export const KEY_FORM_EX_CP_COL_ADDR_CN = 'form_ex_cp_col_addr_cn'
export const KEY_FORM_EX_CP_COL_ADDR_EN = 'form_ex_cp_col_addr_en'
export const KEY_FORM_EX_CP_COL_OTHER = 'form_ex_cp_col_other'
export const KEY_FORM_EX_CP_COL_C_PHONE = 'form_ex_cp_col_c_phone'
export const KEY_FORM_EX_CP_COL_C_EMAIL = 'form_ex_cp_col_c_email'

export const KEY_FORM_EX_CS_TITLE_1 = 'form_ex_cs_title_1'

export const KEY_FORM_EX_RB_TITLE_1 = 'form_ex_rb_title_1'
export const KEY_FORM_EX_RB_TM_REG = 'form_ex_rb_tm_reg'
export const KEY_FORM_EX_RB_TM_HOLDER = 'form_ex_rb_tm_holder'
export const KEY_FORM_EX_RB_TM_HOLDER_ADDR = 'form_ex_rb_tm_holder_addr'
export const KEY_FORM_EX_RB_TM_HOLDER_ID = 'form_ex_rb_tm_holder_id'
export const KEY_FORM_EX_RB_TM_HOLDER_REG = 'form_ex_rb_tm_holder_reg'
export const KEY_FORM_EX_RB_TM_HOLDER_BUS = 'form_ex_rb_tm_holder_bus'
export const KEY_FORM_EX_RB_TM_HOLDER_DIR = 'form_ex_rb_tm_holder_dir'
export const KEY_FORM_EX_RB_TM_ICON = 'form_ex_rb_tm_icon'
export const KEY_FORM_EX_RB_TM_TYPE = 'form_ex_rb_tm_type'
export const KEY_FORM_EX_RB_TM_DESC = 'form_ex_rb_tm_desc'

export const KEY_FORM_CREDIT_TOTAL = 'form_credit_total'
export const KEY_FORM_CREDIT_ADD_TO = 'form_credit_add_to'

// key - Payment
export const KEY_LABEL_PAY = 'label_pay'
export const KEY_LABEL_VAL_ADDED = 'label_val_added'
export const KEY_LABEL_RETURN_INDI = 'label_return_indi'
export const KEY_LABEL_PAYMENT_SUCC = 'label_payment_succ'
export const KEY_LABEL_PAYMENT_FAILED = 'label_payment_failed'
export const KEY_LABEL_PAYMENT_CANCEL = 'label_payment_cancel'

// key - Suggestion
export const KEY_ERROR_SUG_NOT_FILLED = 'error_sug_not_filled'
export const KEY_NOTI_SUG_SENT_SUCC = 'noti_sug_sent_succ'
export const KEY_ERROR_SUG_SENT_FAILED = 'error_sug_sent_failed'
export const KEY_LABEL_SUG_ENQUIRY_TYPE = 'label_sug_enquiry_type'
export const KEY_LABEL_SUG_NAME = 'label_sug_name'
export const KEY_LABEL_SUG_EMAIL = 'label_sug_email'
export const KEY_LABEL_SUG_PHONE = 'label_sug_phone'
export const KEY_LABEL_SUG_MSG = 'label_sug_msg'
export const KEY_LABEL_SUG_SEND = 'label_sug_send'

// key - Wallet
export const KEY_COL_APPLIER = 'col_applier'
export const KEY_COL_AMOUNT = 'col_amount'
export const KEY_COL_UPDATED_AT = 'col_updated_at'
export const KEY_COL_STATUS = 'col_status'
export const KEY_ERROR_VAL_ADDED_FAILED = 'error_val_added_failed'
export const KEY_LABEL_WALLET_CURRENT_CREDIT = 'label_wallet_current_credit'
export const KEY_LABEL_WALLET_OTHER_PAYMENTS = 'label_wallet_other_payments'
export const KEY_VALUE_100 = 'value_100'
export const KEY_VALUE_200 = 'value_200'
export const KEY_VALUE_500 = 'value_500'
export const KEY_VALUE_1000 = 'value_1000'
export const KEY_VALUE_2000 = 'value_2000'
export const KEY_VALUE_3000 = 'value_3000'
export const KEY_BTN_VAL_ADDED = 'btn_val_added'
export const KEY_LABEL_PAST_RECORD = 'label_past_record'

// key - Suggestion Reply Type Selection
export const KEY_LABEL_REPLY_TYPE_HKR = 'label_reply_type_hkr'
export const KEY_LABEL_REPLY_TYPE_OSR = 'label_reply_type_osr'
export const KEY_LABEL_REPLY_TYPE_AS = 'label_reply_type_as'
export const KEY_LABEL_REPLY_TYPE_CS = 'label_reply_type_cs'
export const KEY_LABEL_REPLY_TYPE_SO = 'label_reply_type_so'
export const KEY_LABEL_REPLY_TYPE_VO = 'label_reply_type_vo'
export const KEY_LABEL_REPLY_TYPE_VA = 'label_reply_type_va'